import { ColumnDef } from '@tanstack/react-table'
import dayjs from 'dayjs'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import { RouteParams } from '../../../api/globalTypes'
import { FormSubmissionResponse } from '../../../api/inDepthAnalysis/types'
import BadgeRiskAssessment from '../BadgeRiskAssessment/BadgeRiskAssessment'

export const useTableColumns = (handlePrint: (id: number) => void, formUrl: (id: string) => string): ColumnDef<FormSubmissionResponse>[] => {
    const { t } = useTranslation()
    const { id } = useParams<RouteParams>()

    return useMemo(
        (): ColumnDef<FormSubmissionResponse>[] => [
            {
                header: t('app.common.id'),
                id: 'id',
                accessorKey: 'id',
                enableSorting: false,
                size: 50,
            },
            {
                header: 'Ime i prezime agenta',
                id: 'agent',
                enableSorting: false,
                size: 200,
                cell: ({ row }) => (
                    <span>
                        {row.original.agent.firstName} {row.original.agent.lastName}
                    </span>
                ),
            },
            {
                header: 'Procjena rizika',
                id: 'riskAssessment',
                enableSorting: false,
                size: 150,
                cell: ({ row }) => <BadgeRiskAssessment riskAssessment={row.original.riskAssessment} />,
            },
            {
                header: t('app.common.creationDate'),
                id: 'created',
                enableSorting: false,
                size: 180,
                cell: ({ row }) => dayjs(row.original.created).format('DD.MM.YYYY., HH:mm:ss'),
            },
            {
                id: 'actions',
                enableSorting: false,
                enableResizing: false,
                size: 80,
                meta: { thDivClass: 'text-center', stopPropagation: true },
                cell: ({ row }) => (
                    <ul className="list-inline hstack gap-2 mb-0 justify-content-center">
                        <li className="list-inline-item">
                            <span
                                title={t('app.common.print.title')}
                                className="text-info d-inline-block cursor-pointer"
                                onClick={() => handlePrint(row.original.id)}
                            >
                                <i className="mdi mdi-file-document-multiple-outline align-bottom me-2 text-muted"></i>
                            </span>
                        </li>
                        <li className="list-inline-item edit">
                            <Link
                                title={t('button.edit')}
                                to={formUrl(id) + `&edit=true&id=${row.original.id}`}
                                className="text-info d-inline-block edit-item-btn"
                            >
                                <i className="mdi mdi-pencil-outline fs-16"></i>
                            </Link>
                        </li>
                    </ul>
                ),
            },
        ],
        [t, id, handlePrint, formUrl]
    )
}
